function yearsAgo(dateFrom, dateTo){
    // This is the number of milliseconds in a "Julian year" ($365.25$ days). It’s the gold standard for quick date math because it accounts for leap years over long periods.
    return ((dateTo || new Date()) - dateFrom) / 3.15576e10 | 0;
}

export {
    yearsAgo
};